import { MetaTags } from '@components/MetaTags';
import BookingHeroSection from '@composites/BookingHeroSection';
import Tickets, { Ticket } from '@composites/Tickets';
import { getEventDetails } from '@store/slices/eventSlice';
import { getImageSrc } from '@utils/fn';
import { useEffect, useState, useRef, useCallback } from 'react';
import { fetchTicketsByPageType } from '@utils/ticketUtils';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { MktVipPassTicketsWrapper } from './styles';

const MktVipPassPage = () => {
  const { t } = useTranslation();
  const sluggedEvent = useSelector(getEventDetails)?.[0];
  const { pathname } = useLocation();
  const ticketsRef = useRef<HTMLDivElement>(null);
  const slug = pathname.split('/').filter(Boolean).pop() ?? '';

  const [tickets, setTickets] = useState<Ticket[]>([]);

  useEffect(() => {
    if (sluggedEvent?.slug) {
      // Use 'mkt-vip-pass' as the page type to fetch relevant tickets
      fetchTicketsByPageType(sluggedEvent.slug, 'mkt-vip-pass')
        .then(ticketsData => {
          setTickets(ticketsData);
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error('error = ', err);
        });
    }
  }, [sluggedEvent, pathname]);

  const scrollToTickets = useCallback(() => {
    if (ticketsRef.current) {
      ticketsRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <>
      <MetaTags
        title={`${sluggedEvent?.name} ${slug?.split('-')?.join(' ')}`}
        description={`${sluggedEvent?.name} ${slug?.split('-')?.join(' ')}`}
        keywords={`${sluggedEvent?.slug}, ${slug?.split('-')?.join(', ')}`}
        image={getImageSrc(sluggedEvent?.design?.eventLogoPosSvg)}
        url={window.location.href}
        twitterCardType="summary"
        type="product"
      />
      <BookingHeroSection
        backgroundImage="https://media.we-conect.com/images/website/book_now_hero_section.png"
        darkOverlay
        title={t('mkt-vip-pass-title')}
        description={t('mkt-vip-pass-description')}
        // buttonText={t('mkt-vip-pass-button')}
        // buttonOnClick={scrollToTickets}
      />
      {tickets.length > 0 && (
        <MktVipPassTicketsWrapper ref={ticketsRef}>
          <Tickets
            hasBorderTop
            hasFullContent={true}
            tickets={tickets}
          />
        </MktVipPassTicketsWrapper>
      )}
    </>
  );
};

export default MktVipPassPage;
